import { Component } from "@kluntje/core";

/**
 * a component to trigger the browser print mechanism
 */
class FRAPrint extends Component {
  constructor() {
    super({
      events: [
        {
          event: "click",
          target: "this",
          handler: "print",
        },
      ],
    });
  }

  /**
   * call window print function
   */
  print(): void {
    window.print();
  }
}

customElements.define("fra-e-print", FRAPrint);

export default FRAPrint;
